import {Component} from '@angular/core';

@Component({
  selector: 'ebd-root',
  template: '<router-outlet></router-outlet>'
})
export class AppComponent {
}
